import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../../../ui/dialog';
import { Button } from '../../../ui/button';
import { Label } from '../../../ui/label';
import { Textarea } from '../../../ui/textarea';

interface OverwatchNotesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (notes: string) => void;
  userName: string;
  currentNotes: string;
}

export function OverwatchNotesDialog({
  isOpen,
  onClose,
  onConfirm,
  userName,
  currentNotes
}: OverwatchNotesDialogProps) {
  const [notes, setNotes] = useState<string>(currentNotes);

  const handleConfirm = () => {
    onConfirm(notes);
    onClose();
  };

  const handleClose = () => {
    setNotes(currentNotes);
    onClose();
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) handleClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Add Overwatch Notes for {userName}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="overwatch-notes">Notes</Label>
            <Textarea
              id="overwatch-notes"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Enter overwatch notes..."
              rows={4}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={handleConfirm}>
            Save Notes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}